// Câu báo ô ngày vô lý (./dateSanity): năm gõ thiếu chữ số (⇒ 0026) hoặc «đến» trước «từ».
// `review` = người DUYỆT đang xem đơn đã gửi — ca gốc APR-2609-290 qua ba cấp duyệt mà không ai thấy năm 0026.
import { AlertTriangle } from 'lucide-react';
import { useLingui } from '@lingui/react/macro';

export default function DateIssueHint({ issue, review = false }) {
  const { t } = useLingui();
  if (!issue) return null;
  let text;
  if (review) {
    text = issue.code === 'invalid_year'
      ? t`Năm ${issue.year} bất thường — có thể người gửi gõ thiếu chữ số năm. Hãy trả lại đơn để sửa trước khi duyệt.`
      : t`Thời điểm kết thúc đang trước thời điểm bắt đầu — hãy trả lại đơn để sửa trước khi duyệt.`;
  } else {
    text = issue.code === 'invalid_year'
      ? t`Năm ${issue.year} không hợp lệ — hãy gõ đủ 4 chữ số năm.`
      : t`Thời điểm kết thúc đang trước thời điểm bắt đầu.`;
  }
  return (
    <p className="mt-1 flex items-start gap-1 text-[11px] font-medium text-red-600" role="alert">
      <AlertTriangle size={11} className="mt-0.5 shrink-0" /> <span>{text}</span>
    </p>
  );
}
